/* Kate Day: settings are the source of truth for visible dates and times. */
(function (global) {
  'use strict';
  const DAY = 86400000;
  function validDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
    const date = new Date(value + 'T00:00:00Z');
    return Number.isFinite(+date) && date.toISOString().slice(0, 10) === value;
  }
  function validTime(value) { return /^([01]\d|2[0-3]):[0-5]\d$/.test(value || ''); }
  function expandRange(start, end) {
    if (!validDate(start) || !validDate(end) || end < start) throw new Error('Invalid date range');
    const count = (Date.parse(end) - Date.parse(start)) / DAY + 1;
    if (count > 31) throw new Error('Schedule is too long');
    return Array.from({length:count}, (_, i) => new Date(Date.parse(start) + i * DAY).toISOString().slice(0, 10));
  }
  function rangeLabel(start, end) {
    expandRange(start, end);
    const fmt = new Intl.DateTimeFormat('en-US', {timeZone:'UTC', month:'short', day:'numeric'});
    const a = fmt.format(new Date(start+'T00:00:00Z')).toUpperCase();
    if (start === end) return a;
    const b = start.slice(0,7) === end.slice(0,7) ? String(Number(end.slice(8))) : fmt.format(new Date(end+'T00:00:00Z')).toUpperCase();
    return a + '–' + b;
  }
  function timeLabel(start, end) {
    if (!validTime(start) || !validTime(end) || end <= start) throw new Error('Invalid time range');
    const fmt = v => { const [h,m] = v.split(':').map(Number); return `${h % 12 || 12}${m ? ':' + String(m).padStart(2,'0') : ''} ${h < 12 ? 'AM' : 'PM'}`; };
    return `${fmt(start)}–${fmt(end)} PT`;
  }
  const api = {validDate,validTime,expandRange,rangeLabel,timeLabel};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.document || global.KateDay2026Demo) return;
  global.KateDay2026Demo = api;
  const doc = global.document;
  function init(root = doc) {
    root.querySelectorAll('[data-kd-date-range], [data-kd-event-range]').forEach(node => {
      try {
        const label = rangeLabel(node.dataset.startDate,node.dataset.endDate);
        if (node.hasAttribute('data-kd-date-range')) node.textContent = label;
        else node.querySelector('[data-kd-range-label]').textContent = label;
      } catch (_) { /* Keep the editable Liquid fallback when a setting is invalid. */ }
    });
    root.querySelectorAll('[data-kd-time]').forEach(node => {
      try { node.textContent = timeLabel(node.dataset.startTime,node.dataset.endTime); } catch (_) { /* Keep the editable Liquid fallback. */ }
    });
    const hero = doc.querySelector('[data-kd-date-range]');
    doc.querySelectorAll('[data-kd-hero-range]').forEach(node => {
      if (hero) node.textContent = '/ ' + hero.textContent + ' PT';
    });
    root.querySelectorAll('[data-kd-copy]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', async () => {
        const area = button.closest('.kd-demo-lucky'), status = area.querySelector('[data-kd-copy-status]');
        try {
          if (!button.dataset.kdCopy) throw new Error('Empty code');
          await navigator.clipboard.writeText(button.dataset.kdCopy);
          status.textContent = area.dataset.kdCopySuccess;
        } catch (_) { status.textContent = area.dataset.kdCopyError; }
      });
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded',() => init()); else init();
  doc.addEventListener('shopify:section:load',event => init(event.target));
})(typeof window === 'undefined' ? globalThis : window);
